import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  documentHeaders: [],
  loadingDocumentHeaders: false,
  errorLoadingDocumentHeaders: null,

  loadingDocumentHeaderUpdate: false,
  errorUpdatingDocumentHeader: null,

  serverStatus: null,
};

export const documentHeaderSlice = createSlice({
  name: "documentHeader",
  initialState,
  reducers: {
    setLoadingDocumentHeaders: (state) => {
      state.loadingDocumentHeaders = true;
      state.errorLoadingDocumentHeaders = null;
    },
    setDocumentHeaders: (state, { payload }) => {
      state.loadingDocumentHeaders = false;
      state.documentHeaders = payload;
    },
    setErrorLoadingDocumentHeaders: (state, { payload }) => {
      state.loadingDocumentHeaders = false;
      state.errorLoadingDocumentHeaders = payload;
    },

    setLoadingDocumentHeaderUpdate: (state) => {
      state.loadingDocumentHeaderUpdate = true;
      state.errorUpdatingDocumentHeader = null;
    },
    updateDocumentHeaderSuccess: (state, { payload }) => {
      state.loadingDocumentHeaderUpdate = false;
      // Update the local list
      state.documentHeaders = state.documentHeaders.map((header) =>
        header.id === payload.id ? payload : header,
      );
    },
    setErrorUpdatingDocumentHeader: (state, { payload }) => {
      state.loadingDocumentHeaderUpdate = false;
      state.errorUpdatingDocumentHeader = payload;
    },

    setServerResponseStatus: (state, { payload }) => {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingDocumentHeaders,
  setDocumentHeaders,
  setErrorLoadingDocumentHeaders,
  setLoadingDocumentHeaderUpdate,
  updateDocumentHeaderSuccess,
  setErrorUpdatingDocumentHeader,
  setServerResponseStatus,
} = documentHeaderSlice.actions;

export default documentHeaderSlice.reducer;
